export const surveyPDFChartAcquiredTooltips = {
  IHA: "In House\nAcquired",
  IHAw: "In House\nAcquired Worsening",
  POA: "Present\non Admission",
  PIHAw: "Present on\nAdmission In House\nAcquired Worsening"
};
